module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_vm._m(0), _vm._m(1), _vm._v(" "), _c('svg', {
    attrs: {
      "height": "99%",
      "preserveaspectratio": "xMidYMid meet",
      "version": "1.1",
      "viewbox": "0 0 600 919",
      "width": "100%",
      "xmlns": "http://www.w3.org/2000/svg",
      "xmlns:xlink": "http://www.w3.org/1999/xlink"
    }
  }, [_c('image', {
    staticStyle: {
      "max-width": "100%",
      "max-height": "100%"
    },
    attrs: {
      "height": "919",
      "width": "600",
      "xlink:href": require("../data/content-0001.jpg")
    }
  })]), _vm._m(2), _vm._v(" "), _c('div', {
    staticClass: "flow"
  }), _vm._v(" "), _vm._m(3), _vm._m(4), _vm._m(5), _vm._m(6), _vm._v(" "), _vm._m(7), _vm._m(8), _vm._v(" "), _vm._m(9), _vm._m(10), _vm._m(11), _vm._m(12), _vm._v(" "), _vm._m(13), _vm._m(14), _vm._v(" "), _vm._m(15), _vm._m(16), _vm._m(17), _vm._v(" "), _vm._m(18), _vm._v(" "), _vm._m(19)])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticStyle: {
      "display": "none"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PP1"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PP1.w.0.0.0"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticStyle: {
      "display": "none"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PP1.w.1.0.0"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "flow"
  }, [_c('a', {
    staticClass: "page full_page_image",
    attrs: {
      "id": "ORIG-GBS.PP1"
    }
  }), _vm._v(" "), _c('a', {
    attrs: {
      "id": "GBS.PP1.w.2.0.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PP1.w.2.0.0.1"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "flow"
  }, [_c('div', {
    staticClass: "pagebreak"
  }), _vm._v(" "), _c('a', {
    staticClass: "page",
    attrs: {
      "id": "ORIG-GBS.PA1"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "gtxt_body",
    attrs: {
      "id": "block.2.0.0.box.578.758.368.184.q.70"
    }
  }, [_c('a', {
    attrs: {
      "id": "ORIG-GBS.PA1.w.0.0.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "font-size": "110%",
      "text-indent": "0",
      "text-align": "center",
      "font-weight": "bold",
      "color": "rgb(0, 0, 0)"
    },
    attrs: {
      "id": "para.2.0.0.box.578.758.368.184.q.70"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PP1.w.2.1.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PP1.w.2.2.0"
    }
  }), _vm._v("HITLER "), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PP1.w.3.0.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PP1.w.3.1.0"
    }
  }), _vm._v("Came ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PP1.w.3.2.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PP1.w.3.3.0"
    }
  }), _vm._v("for ")]), _c('a', {
    attrs: {
      "id": "GBS.PP1.w.3.4.0"
    }
  }), _vm._v("NIEMOELLER")]), _c('a', {
    attrs: {
      "id": "GBS.PP1.w.3.5.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PP1.w.3.6.0"
    }
  })]), _c('a', {
    attrs: {
      "id": "GBS.PP1.w.3.7.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PP1.w.3.8.0"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticStyle: {
      "display": "none"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PP1.w.3.9.0"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticStyle: {
      "display": "none"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PP1.w.3.10.0"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticStyle: {
      "display": "none"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PP1.w.4.0.0"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "flow"
  }, [_c('a', {
    attrs: {
      "id": "GBS.PP1.w.4.1.0"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "pagebreak"
  }), _c('a', {
    attrs: {
      "id": "GBS.PP2"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PP2.w.0.0.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA1"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA1.w.0.0.0"
    }
  }), _vm._v(" "), _c('a', {
    attrs: {
      "id": "GBS.PA1.w.0.0.0.1"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA1.w.0.1.0"
    }
  }), _c('a', {
    staticClass: "page",
    attrs: {
      "id": "ORIG-GBS.PA2"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA1.w.0.2.0"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "gimg_graphic",
    attrs: {
      "id": "block.3.0.0.box.192.278.1204.1722.q.60"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA2"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA2.w.0.0.0"
    }
  }), _vm._v(" "), _c('a', {
    attrs: {
      "id": "GBS.PA2.w.1.0.0"
    }
  }), _c('img', {
    staticStyle: {
      "max-width": "100%",
      "max-height": "100%"
    },
    attrs: {
      "alt": "[graphic]",
      "src": "data/content-0002.jpg"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA2.w.1.0.0.1"
    }
  })]), _c('a', {
    attrs: {
      "id": "GBS.PA2.w.1.1.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA2.w.1.2.0"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticStyle: {
      "display": "none"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA3"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA3.w.0.0.0"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticStyle: {
      "display": "none"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA3.w.0.0.0.1"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticStyle: {
      "display": "none"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA3.w.0.1.0"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "flow"
  }, [_c('div', {
    staticClass: "pagebreak"
  }), _vm._v(" "), _c('a', {
    staticClass: "page",
    attrs: {
      "id": "ORIG-GBS.PA3"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "gtxt_body",
    staticStyle: {
      "margin-bottom": "1.5em"
    },
    attrs: {
      "id": "block.4.0.0.box.182.400.1160.534.q.90"
    }
  }, [_c('a', {
    attrs: {
      "id": "ORIG-GBS.PA3.w.0.0.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "font-size": "172%",
      "text-indent": "0",
      "text-align": "center",
      "font-weight": "bold",
      "color": "rgb(0, 0, 0)"
    },
    attrs: {
      "id": "para.4.0.0.box.182.400.1160.534.q.90"
    }
  }, [_vm._v("HITLER "), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("Came ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("for ")]), _c('a', {
    attrs: {
      "id": "GBS.PA3.w.0.2.0"
    }
  }), _vm._v("NIEMOELLER")])]), _vm._v(" "), _c('div', {
    staticClass: "gtxt_body",
    staticStyle: {
      "margin-bottom": "1.5em"
    },
    attrs: {
      "id": "block.4.1.0.box.316.996.880.310.q.90"
    }
  }, [_c('a', {
    attrs: {
      "id": "ORIG-GBS.PA3.w.1.0.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "font-size": "150%",
      "text-indent": "0",
      "text-align": "center",
      "font-weight": "bold",
      "color": "rgb(0, 0, 0)"
    },
    attrs: {
      "id": "para.4.1.0.box.316.996.880.310.q.90"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA3.w.0.3.0"
    }
  }), _vm._v("The Nazi War Against Religion")])]), _vm._v(" "), _c('div', {
    staticClass: "gtxt_body",
    attrs: {
      "id": "block.4.2.0.box.248.1372.1022.186.q.60"
    }
  }, [_c('a', {
    attrs: {
      "id": "ORIG-GBS.PA3.w.2.0.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "font-size": "122%",
      "text-align": "center",
      "font-weight": "bold",
      "text-indent": "0",
      "color": "rgb(0, 0, 0)"
    },
    attrs: {
      "id": "para.4.2.0.box.548.1372.420.86.q.80"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA3.w.0.4.0"
    }
  }), _vm._v("By Leo Stein")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PA3.w.2.1.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "font-size": "116%",
      "text-align": "center",
      "font-weight": "bold",
      "text-indent": "0",
      "color": "rgb(0, 0, 0)"
    },
    attrs: {
      "id": "para.4.2.1.box.248.1482.1022.76.q.90"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA3.w.0.5.0"
    }
  }), _vm._v("Foreword by Norman Vincent Peale")])]), _vm._v(" "), _c('div', {
    staticClass: "gimg_graphic",
    staticStyle: {
      "margin-top": "5em"
    },
    attrs: {
      "id": "block.4.3.0.box.708.1958.106.96.q.40"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA3.w.1.0.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA3.w.2.0.0"
    }
  }), _c('img', {
    staticStyle: {
      "max-width": "100%",
      "max-height": "100%"
    },
    attrs: {
      "alt": "[graphic]",
      "src": "data/content-0003.png"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA3.w.2.0.0.1"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "gtxt_body",
    attrs: {
      "id": "block.4.4.0.box.397.2077.729.87.q.90"
    }
  }, [_c('a', {
    attrs: {
      "id": "ORIG-GBS.PA3.w.4.0.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "font-size": "102%",
      "text-align": "center",
      "color": "rgb(0, 0, 0)"
    },
    attrs: {
      "id": "para.4.4.0.box.397.2077.729.32.q.100"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA3.w.2.1.0"
    }
  }), _vm._v("PELICAN PUBLISHING COMPANY")]), _c('a', {
    attrs: {
      "id": "GBS.PA3.w.3.0.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA3.w.4.0.0"
    }
  }), _vm._v(" "), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PA3.w.4.1.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "font-size": "102%",
      "text-align": "center"
    },
    attrs: {
      "id": "para.4.4.1.box.637.2131.245.33.q.90"
    }
  }, [_vm._v("Gretna 2003")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticStyle: {
      "display": "none"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA4"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA4.w.0.0.0"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "flow"
  }, [_c('div', {
    staticClass: "pagebreak"
  }), _vm._v(" "), _c('a', {
    staticClass: "page",
    attrs: {
      "id": "ORIG-GBS.PA4"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "gtxt_body",
    attrs: {
      "id": "block.5.0.0.box.190.209.667.359.q.50"
    }
  }, [_c('a', {
    attrs: {
      "id": "ORIG-GBS.PA4.w.0.0.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body gtxt_lineated",
    staticStyle: {
      "margin-left": "0",
      "color": "rgb(0, 0, 0)"
    },
    attrs: {
      "id": "para.5.0.0.box.192.209.568.90.q.50"
    }
  }, [_vm._v("Copyright © 1942 "), _c('br'), _c('a', {
    attrs: {
      "id": "GBS.PA4.w.1.0.0"
    }
  }), _vm._v("By Fleming H. Revell Company "), _c('br')]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PA4.w.0.1.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body gtxt_lineated",
    staticStyle: {
      "margin-left": "0",
      "color": "rgb(0, 0, 0)"
    },
    attrs: {
      "id": "para.5.0.1.box.190.321.667.139.q.70"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA4.w.1.1.0"
    }
  }), _vm._v("Copyright © 2003 "), _c('br'), _c('a', {
    attrs: {
      "id": "GBS.PA4.w.1.2.0"
    }
  }), _vm._v("By Pelican Publishing Company, Inc. "), _c('br'), _c('a', {
    attrs: {
      "id": "GBS.PA4.w.1.3.0"
    }
  }), _vm._v("All rights reserved "), _c('br')]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PA4.w.0.2.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body gtxt_lineated",
    staticStyle: {
      "margin-left": "0",
      "color": "rgb(0, 0, 0)"
    },
    attrs: {
      "id": "para.5.0.2.box.192.484.472.84.q.70"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA4.w.1.4.0"
    }
  }), _vm._v("First edition, 1942 "), _c('br'), _c('a', {
    attrs: {
      "id": "GBS.PA4.w.1.5.0"
    }
  }), _vm._v("First Pelican edition, 2003 "), _c('br')])]), _vm._v(" "), _c('div', {
    staticClass: "gtxt_inset_box",
    staticStyle: {
      "margin-top": "3em"
    },
    attrs: {
      "id": "block.5.1.0.box.261.784.1059.138.q.70"
    }
  }, [_c('a', {
    attrs: {
      "id": "ORIG-GBS.PA4.w.1.0.0"
    }
  }), _c('p', {
    staticClass: "gtxt_inset_box",
    staticStyle: {
      "text-align": "center",
      "color": "rgb(0, 0, 0)"
    },
    attrs: {
      "id": "para.5.1.0.box.261.784.1059.138.q.70"
    }
  }, [_c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA4.w.2.0.0"
    }
  }), _vm._v("The ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("word ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("\"Pelican")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("\" ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("and ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("the ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("depiction ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("of ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("a ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("pelican ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("are ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("trademarks ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA4.w.2.1.0"
    }
  }), _vm._v("of ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("Pelican ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("Publishing ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("Company, ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("Inc., ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("and ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("are ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("registered ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA4.w.2.2.0"
    }
  }), _vm._v("in ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("the ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("U.S. ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("Patent ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("and ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("Trademark ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("Office. ")])])]), _vm._v(" "), _c('div', {
    staticClass: "gtxt_body",
    staticStyle: {
      "margin-bottom": "1.5em",
      "margin-top": "3em"
    },
    attrs: {
      "id": "block.5.2.0.box.324.1033.926.38.q.80"
    }
  }, [_c('a', {
    attrs: {
      "id": "ORIG-GBS.PA4.w.2.0.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "text-indent": "0",
      "text-align": "center",
      "font-weight": "bold",
      "color": "rgb(0, 0, 0)"
    },
    attrs: {
      "id": "para.5.2.0.box.324.1033.926.38.q.80"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA4.w.3.0.0"
    }
  }), _vm._v("Library of Congress Cataloging-in-Publication Data")])]), _vm._v(" "), _c('div', {
    staticClass: "gtxt_body",
    staticStyle: {
      "margin-bottom": "1.5em"
    },
    attrs: {
      "id": "block.5.3.0.box.193.1131.1187.487.q.30"
    }
  }, [_c('a', {
    attrs: {
      "id": "ORIG-GBS.PA4.w.3.0.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "color": "rgb(0, 0, 0)"
    },
    attrs: {
      "id": "para.5.3.0.box.193.1131.191.33.q.70"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA4.w.3.1.0"
    }
  }), _vm._v("Stein, Leo.")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PA4.w.3.1.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "text-indent": "1em",
      "margin-left": "1em",
      "color": "rgb(0, 0, 0)"
    },
    attrs: {
      "id": "para.5.3.1.box.229.1180.1132.129.q.40"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA4.w.3.2.0"
    }
  }), _vm._v("Hitler came for Niemoeller : the Nazi War against religion / by Leo Stein ; foreword by Norman Vincent Peale.— 1st Pelican ed.")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PA4.w.3.2.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "text-indent": "2em",
      "margin-left": "1em",
      "color": "rgb(0, 0, 0)"
    },
    attrs: {
      "id": "para.5.3.2.box.304.1339.109.31.q.50"
    }
  }, [_vm._v("p. cm.")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PA4.w.3.3.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "text-indent": "1em",
      "margin-left": "1em",
      "color": "rgb(0, 0, 0)"
    },
    attrs: {
      "id": "para.5.3.3.box.267.1380.928.39.q.60"
    }
  }, [_vm._v("Originally published: New York : F. H. Revell, 1942.")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PA4.w.3.4.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "text-indent": "1em",
      "margin-left": "1em",
      "color": "rgb(0, 0, 0)"
    },
    attrs: {
      "id": "para.5.3.4.box.268.1429.649.40.q.80"
    }
  }, [_vm._v("Includes bibliographical references.")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PA4.w.3.5.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "text-indent": "1em",
      "margin-left": "1em",
      "color": "rgb(0, 0, 0)"
    },
    attrs: {
      "id": "para.5.3.5.box.268.1479.484.39.q.50"
    }
  }, [_vm._v("ISBN 1-58980-063-X (pbk.)")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PA4.w.3.6.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "text-indent": "1em",
      "margin-left": "1em",
      "color": "rgb(0, 0, 0)"
    },
    attrs: {
      "id": "para.5.3.6.box.230.1529.1150.89.q.50"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA4.w.3.3.0"
    }
  }), _vm._v("1. Niemoeller, Martin, 1892- 2. Lutheran Church—Germany—Clergy—Biography. I. Title.")])]), _vm._v(" "), _c('div', {
    staticClass: "gtxt_body",
    attrs: {
      "id": "block.5.4.0.box.230.1676.1152.181.q.20"
    }
  }, [_c('a', {
    attrs: {
      "id": "ORIG-GBS.PA4.w.4.0.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body gtxt_lineated",
    staticStyle: {
      "margin-left": "1em",
      "color": "rgb(0, 0, 0)"
    },
    attrs: {
      "id": "para.5.4.0.box.230.1676.390.137.q.20"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA4.w.3.4.0"
    }
  }), _vm._v("BX8080.N48S74 2003 "), _c('br'), _vm._v("284.1'092—dc21 "), _c('br'), _vm._v("[B] "), _c('br')]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PA4.w.4.1.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "text-align": "right",
      "margin-left": "1em",
      "color": "rgb(0, 0, 0)"
    },
    attrs: {
      "id": "para.5.4.1.box.1168.1827.214.30.q.70"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA4.w.3.5.0"
    }
  }), _vm._v("2002193016")])]), _vm._v(" "), _c('div', {
    staticClass: "gimg_graphic",
    staticStyle: {
      "float": "none"
    },
    attrs: {
      "id": "block.5.5.0.box.179.1903.1196.122.q.101"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA4.w.3.6.0"
    }
  }), _c('img', {
    staticStyle: {
      "max-width": "100%",
      "max-height": "100%"
    },
    attrs: {
      "alt": "[graphic]",
      "src": "data/content-0004.png"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA4.w.3.6.0.1"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "gtxt_body",
    attrs: {
      "id": "block.5.6.0.box.192.2034.874.142.q.60"
    }
  }, [_c('a', {
    attrs: {
      "id": "ORIG-GBS.PA4.w.6.0.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    attrs: {
      "id": "para.5.6.0.box.193.2034.720.29.q.80"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA5"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA5.w.0.0.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA5.w.1.0.0"
    }
  }), _vm._v("Printed in the United"), _c('a', {
    attrs: {
      "id": "GBS.PA5.w.1.1.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA5.w.1.2.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA5.w.1.3.0"
    }
  }), _vm._v(" States of America")]), _c('a', {
    attrs: {
      "id": "GBS.PA5.w.1.4.0"
    }
  }), _vm._v(" "), _c('a', {
    attrs: {
      "id": "GBS.PA5.w.1.4.0.1"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA5.w.1.5.0"
    }
  }), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PA4.w.6.1.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    attrs: {
      "id": "para.5.6.1.box.192.2093.855.39.q.70"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA5.w.1.6.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA5.w.1.7.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA5.w.1.8.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA5.w.1.9.0"
    }
  }), _vm._v("Published by Pelican "), _c('a', {
    attrs: {
      "id": "GBS.PA5.w.1.10.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA5.w.1.11.0"
    }
  }), _vm._v("Publishing Company, Inc.")]), _c('a', {
    attrs: {
      "id": "GBS.PA5.w.1.12.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA5.w.1.13.0"
    }
  }), _vm._v(" "), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PA4.w.6.2.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    attrs: {
      "id": "para.5.6.2.box.197.2141.869.35.q.70"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA5.w.1.14.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA5.w.1.15.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA5.w.1.16.0"
    }
  }), _vm._v("1000 Burmaster Street"), _c('a', {
    attrs: {
      "id": "GBS.PA5.w.1.17.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA5.w.1.18.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA5.w.2.0.0"
    }
  }), _vm._v(", Gretna, Louisiana 70053")]), _c('a', {
    attrs: {
      "id": "GBS.PA6"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA6.w.0.0.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA6.w.1.0.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA6.w.1.1.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA6.w.1.2.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA6.w.1.3.0"
    }
  })])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticStyle: {
      "display": "none"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA7"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA7.w.0.0.0"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticStyle: {
      "display": "none"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA7.w.0.0.0.1"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticStyle: {
      "display": "none"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA7.w.0.0.0.2"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "flow"
  }, [_c('a', {
    staticClass: "page full_page_skipped",
    attrs: {
      "id": "ORIG-GBS.PA5"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "flow"
  }, [_c('a', {
    staticClass: "page full_page_skipped",
    attrs: {
      "id": "ORIG-GBS.PA6"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticStyle: {
      "display": "none"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA7.w.0.0.0.3"
    }
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-58d2d9f4","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/content/content-0005.vue
// module id = 54
// module chunks = 0